<ng-template #actionModal let-modal>
  <div class="modal-body">
    @if (showHeader) {
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="header-icon {{ headerIconState }}">
          <ng-content select="[headerIcon]" />
        </div>
        <app-cross-icon
          height="20px"
          width="20px"
          color="var(--gray-600)"
          (click)="cancel()"
          class="clickable"
        />
      </div>
    }
    <div class="main-title"><ng-content select="[mainTitle]" /></div>
    <div class="subtitle"><ng-content select="[subtitle]" /></div>
    <!-- Projected content brings its own spacing, so an unused slot leaves no gap. -->
    <ng-content select="[body]" />
    <div [ngClass]="{ 'modal-buttons': true, 'full-width': fullWidthFooter }">
      <button
        type="button"
        [disabled]="disabled"
        class="lty-btn lty-btn-white"
        (click)="cancel()"
        i18n
      >
        Annuler
      </button>
      <button
        type="button"
        [disabled]="disabled || submitDisabled"
        class="lty-btn {{ submitButtonClass }}"
        (click)="submit()"
        i18n
      >
        <ng-content select="[submitButtonLabel]" />
      </button>
    </div>
  </div>
</ng-template>
